import { createAction } from 'redux-actions';

import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { UserModel } from '@/shared/models/user.model';
import * as Actions from '@/shared/redux/constants/actions';
import { UserAuthUIModel } from '@/shared/ui-models/user-auth.ui-model';

export const signUpUserRequest = createAction<UserModel>(Actions.REGISTER_USER_REQUEST);
export const signUpUserFailure = createAction<ErrorInfo>(Actions.REGISTER_USER_FAILURE);
export const userDataCleanup = createAction(Actions.USER_DATA_CLEANUP);
export const userDataSuccess = createAction<UserAuthUIModel>(Actions.USER_DATA_SUCCESS);
export const userTeamDataSuccess = createAction<Pick<UserAuthUIModel, 'team'>>(
  Actions.USER_TEAM_DATA_SUCCESS
);

// User Image Actions
export const userImageRequest = createAction(Actions.USER_IMAGE_REQUEST);
export const userImageSuccess = createAction<{ imageUrl: string }>(Actions.USER_IMAGE_SUCCESS);
export const userImageFailure = createAction<ErrorInfo>(Actions.USER_IMAGE_FAILURE);
